import { Component, OnInit } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-website-use',
  templateUrl: './website-use.component.html',
  styleUrls: ['./website-use.component.scss']
})
export class WebsiteUseComponent implements OnInit {

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  constructor(public helperService: HelperService) {}

  ngOnInit(): void {}
}
